/* eslint-disable */
import { createTheme, adaptV4Theme, responsiveFontSizes } from "@mui/material/styles";
import shadows from "./styles/shadows";
import { grey } from "@mui/material/colors";

export const MuiTheme = responsiveFontSizes(
  createTheme(
    adaptV4Theme({
      palette: {
        common: { black: "#000", white: "#fff" },
        background: { paper: "#fff", default: "#fafafa" },
        primary: {
          light: "rgba(28, 193, 255, 1)",
          main: "rgba(28, 173, 228, 1)",
          // main: "linear-gradient(90deg, #4C6DFA -1.03%, #0FF2CD 112.18%)",
          dark: "rgba(16, 121, 161, 1)",
          contrastText: "#fff",
        },
        secondary: {
          light: "rgba(170, 170, 170, 1)",
          main: "rgba(133, 133, 133, 1)",
          dark: "rgba(96, 96, 96, 1)",
          contrastText: "#fff",
        },
        error: { light: "#e57373", main: "rgba(247, 98, 98, 1)", dark: "#d32f2f", contrastText: "#fff" },
        text: {
          primary: "rgba(54, 54, 54, 1)",
          secondary: "rgba(0, 0, 0, 0.54)",
          disabled: "rgba(0, 0, 0, 0.38)",
          // hint: "rgba(0, 0, 0, 0.38)",
        },
        action: {
          selected: "rgba(28, 173, 228, 0.08)",
        },
      },
      shadows: shadows,
      shape: {
        borderRadius: 0,
      },
      typography: {
        fontSize: 11,
        subtitle2: {
          color: grey["500"],
        },
        h4: {
          color: "#363636",
        },
      },
      overrides: {
        MuiCardHeader: {
          content: {
            minWidth: 0,
          },
        },
        MuiButton: {
          contained: {
            boxShadow: "none",
          },
        },
        MuiButtonGroup: {
          contained: {
            boxShadow: "none",
          },
        },
        MuiFormControlLabel: {
          root: {
            marginLeft: 0,
            marginRight: 0,
          },
        },
        MuiInput: {
          underline: {
            "&:before": {
              borderBottom: `1px solid ${grey["300"]}`,
            },
            "&:after": {
              borderBottom: `1px solid ${grey["300"]}`,
            },
          },
        },
        MuiSelect: {
          select: {
            "&:focus": {
              background: "none",
              backgroundColor: "transparent",
            },
          },
        },
        MuiListItem: {
          dense: {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
        MuiTooltip: {
          tooltip: {
            backgroundColor: "white",
            color: "rgba(54, 54, 54, 1)",
            maxWidth: 480,
            padding: 0,
            margin: 0,
            borderRadius: 5,
            fontSize: 12,
          },
        },
      },
    })
  )
);
